import Vue from "vue";
import {CodeToText} from "element-china-area-data";
/**
 * 根据key获取localStorage的值
 * @param {string} name localStorage中存储的key
 * @returns { any } 找到就返回，未找到就返回undefined
 */
export const getStorageItem = (name) => {
  if (!name) return
  const value = window.localStorage.getItem(name)
  return value && value !== 'undefined' && JSON.parse(value)
}
/**
 * 将value以key为键保存到localStorage中
 * @param { string } name 存储到localStorage的key
 * @param { any } value 存储到localStorage的value
 * @returns { void }
 */
export const setStorageItem = (name, value) => {
  if (!name) return
  return window.localStorage.setItem(name, JSON.stringify(value))
}
/**
 * 删除localStorage
 * @param {string} name 删除localStorage中对应的key
 */
export const removeStorageItem = (name) => {
  if (!name) return
  return window.localStorage.removeItem(name)
}
/**
 * 清空localStorage
 */
export const clearStorage = () => {
  return window.localStorage.clear()
}
export const getBeforeDate = (m) => {
  var n = m
  var s = ''
  var d = new Date()
  var year = d.getFullYear()
  var mon = d.getMonth() + 1
  var day = d.getDate()
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1
    } else {
      year = year - 1
      mon = 12
    }
  }
  d.setDate(d.getDate() - n)
  year = d.getFullYear()
  mon = d.getMonth() + 1
  day = d.getDate()
  s = year + '-' + (mon < 10 ? ('0' + mon) : mon) + '-' + (day < 10 ? ('0' + day) : day)
  return s
}

export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}

export const dataPlus = (time, type) => {
  Date.prototype.format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    }
    if(/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for(var k in o){
      if(new RegExp('(' + k + ')').test(fmt)){
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }
  var timestamp = null
  if(type == 'block'){
    // console.log('block ' + type)
    timestamp = Date.parse(time.substr(0, 19) + ".000+00:00")
  } else {
    // console.log('other ' + type)
    timestamp = time
  }
  // console.log(timestamp)
  var time8 = new Date(timestamp).format("yyyy-MM-dd hh:mm:ss")
  return time8
}

export const numberToUpperCase = (textIndex) =>{
  let newString = '';
  let newTextIndex = (textIndex) + '';

  function sum(value, index) {
    var newValue = '';
    if ((textIndex === 9)) {
      return !index ? '十' : '';
    }
   let isSeat = (~~textIndex > 9 && ~~textIndex < 19);
    switch (~~value) {
      case 1:
        newValue = !index ? (isSeat ? '' : '一') : '十一';
        break;
      case 2:
        newValue = !index ? (isSeat ? '' : '二') : '十二';
        break;
      case 3:
        newValue = !index ? (isSeat ? '' : '三') : '十三';
        break;
      case 4:
        newValue = !index ? (isSeat ? '' : '四') : '十四';
        break;
      case 5:
        newValue = !index ? (isSeat ? '' : '五') : '十五';
        break;
      case 6:
        newValue = !index ? (isSeat ? '' : '六') : '十六';
        break;
      case 7:
        newValue = !index ? (isSeat ? '' : '七') : '十七';
        break;
      case 8:
        newValue = !index ? (isSeat ? '' : '八') : '十八';
        break;
      case 9:
        newValue = !index ? (isSeat ? '' : '九') : '九十';
        break;
      case 0:
        newValue = '十';
        break;
      default:
        break;
    }
    return newValue;
  }

  for (let i = 0; i < newTextIndex.length; i++) {
    newString += sum(newTextIndex.substring(i, i + 1), i);
  }
  return newString;
}
/**
 * 判断各种null
 * @param title
 */
export const isNull = (exp) => {
  return !exp || exp == null || exp == '' || typeof (exp) == undefined
}
/**
 * 判断各种null
 * @param title
 */
export const isNotNull = (exp) => {
  return !isNull(exp)
}

export const toastSuc = (msg) => {
  Vue.prototype.$message.success(msg)
}
export const toastError = (msg) => {
  Vue.prototype.$message.error(msg)
}
export const toastWarning = (msg) => {
  Vue.prototype.$message.warning(msg)
}
/**
 * 深度复制  避免实体感染
 * @param source
 * @returns {[]|{}}
 */
export const deepClone = (source) => {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
/**
 * 3个code集合  转换成 省市区
 * @param addressCode
 * @returns {string}
 */
 export  const  addressCode2Name=(addressCode)=>{
  if(addressCode.length>0)  return CodeToText[addressCode[0]] + ' ' + CodeToText[addressCode[1]] + ' ' + CodeToText[addressCode[2]]
 }



// WEBPACK FOOTER //
// ./src/utils/index.js